var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafariPinnedTab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "700.000000pt",
    height: "700.000000pt",
    viewBox: "0 0 700.000000 700.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\n        Created by potrace 1.14, written by Peter Selinger 2001-2017\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,700.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M765 6994 c-11 -2 -45 -9 -75 -15 -201 -39 -407 -175 -524 -344 -74 -108 -95 -151 -134 -275 l-27 -85 -2 -2755 -1 -2755 24 -94 c79 -315 295 -539 611 -638 l88 -28 2775 0 2775 0 88 28 c247 77 432 230 541 447 32 63 61 140 72 191 2 13 9 44 14 69 11 53 8 5512 -3 5551 -57 208 -120 326 -240 448 -119 122 -244 190 -456 248 -26 8 -5489 14 -5526 7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariPinnedTab);
export default __webpack_public_path__ + "static/media/safari-pinned-tab.2029da79b716c8131fedf0e269aab3db.svg";
export { ForwardRef as ReactComponent };